export const portfolioDataEn = {
  name: "Belghith Adem",
  title: "Full-Stack Developer",
  contact: {
    email: "BelghithAdem20@gmail.com",
    phone: "+216 54 021 345",
    location: "Tunisia, Ariana",
    linkedin: "https://linkedin.com/in/belghith-adem-92982b197",
    github: "https://github.com/BelghithAdem",
    gitlab: "https://gitlab.com/BelghithAdem",
    portfolio: "https://belghithadem.netlify.app/"
  },
  profile: "Full-Stack Software Engineer specialized in developing modern, performant, and scalable web applications. Experience with SaaS projects, monorepo, and modern frontend architectures.",
  experience: [
    {
      title: "Full Stack Developer",
      company: "1for1 Learning",
      location: "Sousse, Tunisia",
      date: "01/2026 – Present",
      tasks: [
        "Developing full-stack web applications using Next.js and NestJS.",
        "Building scalable backend services and modern frontend interfaces.",
        "Working on-site in a full-time capacity."
      ],
      technologies: [
        "Next.js",
        "NestJS"
      ]
    },
    {
      title: "Front-End Developer",
      company: "Wee Farm",
      location: "Tunisia",
      date: "09/2025 – 12/2025",
      tasks: [
        "Developed high-performance interfaces with Next.js.",
        "Worked in monorepo (Turborepo) to improve scalability.",
        "Set up Storybook and created reusable UI components.",
        "Collaborated with the product team."
      ],
      technologies: [
        "Next.js",
        "TypeScript",
        "Turborepo",
        "Storybook",
        "Tailwind CSS"
      ]
    },
    {
      title: "Full-Stack Developer",
      company: "Tadkik",
      location: "Tunisia",
      date: "05/2025 – 09/2025",
      tasks: [
        "Developed front-end of a multi-tenant SaaS with Vue 3.",
        "Integrated REST APIs and managed access control.",
        "Created analytical dashboards and scheduling features.",
        "Developed reusable UI components."
      ],
      technologies: [
        "Vue.js",
        "TypeScript",
        "Tailwind CSS",
        "Chart.js",
        "FullCalendar",
        "Mercure",
        "shadcn/ui"
      ]
    },
    {
      title: "Front-End Developer",
      company: "Synque",
      location: "Hong Kong",
      date: "01/2024 – 06/2025",
      tasks: [
        "Created dynamic web pages with modular components using Vue.js.",
        "Redesigned a React Native application to optimize performance and scalability.",
        "Participated in developing a Next.js project with modern front-end features."
      ],
      technologies: [
        "Vue.js",
        "React Native",
        "Tailwind CSS",
        "Next.js"
      ]
    },
    {
      title: "Full-Stack Developer – Summer Internship",
      company: "NEXT STEP",
      location: "Charguia Tunis",
      date: "08/2025 – 09/2025",
      tasks: [
        "Developed scalable API services with FastAPI.",
        "Designed modern user interfaces with Next.js.",
        "Integrated LLM features to provide intelligent suggestions."
      ],
      technologies: [
        "FastAPI",
        "MongoDB Atlas",
        "Next.js",
        "Node.js",
        "Google Gemini",
        "LLM",
        "LangChain"
      ]
    },
    {
      title: "Developer – Summer Internship",
      company: "Orange Tunisia",
      location: "Tunisia",
      date: "07/2025 – 08/2025",
      tasks: [
        "Created a real-time KPI dashboard with Grafana.",
        "Extracted and cleaned data from CSV files.",
        "Connected and integrated the database with Grafana for dashboard visualization."
      ],
      technologies: [
        "Python",
        "ClickHouse",
        "Grafana",
        "REST APIs",
        "SSH"
      ]
    }
  ],
  projects: [
    {
      name: "RentSmart",
      date: "2024 – Present",
      image: "/images/projects/rentsmart.png",
      github: "",
      live: "https://play.google.com/store/apps/details?id=hk.com.rentsmart&hl=fr",
      category: "professional",
      type: "Mobile App (iOS & Android)",
      description: [
        "React Native & Expo iOS and Android application for rent payment in Hong Kong.",
        "Pay rent with credit card, earn miles and cashback. 10k+ downloads on Google Play.",
        "RentSmart - 交租有「里」賞. Residential, commercial, parking, deposits and agency fees."
      ]
    },
    {
      name: "California Gym Music",
      date: "2024 – Present",
      image: "/images/projects/california.png",
      github: "",
      live: "https://music.california-gym.com",
      category: "professional",
      type: "Music Management System",
      description: [
        "Next.js & Node.js music management system for California Gym salle and cours.",
        "Spotify integration, scheduling, advertisements, and playlists from Spotify or file upload.",
        "Manage music across gym rooms (salle cours and other salles)."
      ]
    },
    {
      name: "WeeFarm",
      date: "2024 – Present",
      image: "/images/projects/wee-farm.png",
      github: "",
      live: "https://wee-farm.com/en",
      category: "professional",
      description: [
        "E-commerce platform for farmers built with Next.js and Node.js/Express backend.",
        "Integrated Konnect Pay payment gateway for secure transactions.",
        "Full-stack solution connecting farmers with customers, featuring product management and order processing."
      ]
    },
    {
      name: "Tech Gateway",
      date: "01/2025 – 03/2025",
      image: "/images/projects/techgateway.png",
      github: "",
      live: "https://techgateway.com.tn",
      category: "professional",
      description: [
        "Complete WordPress e-commerce site with advanced SEO optimization.",
        "Secure payment integration, inventory management and analytics.",
        "Optimized performance, responsive design and natural referencing."
      ]
    },
    {
      name: "Dhiya Store",
      date: "12/2024 – 02/2025",
      image: "/images/projects/dihyastore.png",
      github: "",
      live: "https://dihyastore.com/",
      category: "professional",
      description: [
        "WordPress online store specialized in pottery and decoration.",
        "Complete catalog with pots, mugs, plates and decorative objects.",
        "Custom ordering system and integrated pottery courses."
      ]
    },
    {
      name: "Quran App",
      date: "03/2024 – 04/2024",
      image: "/images/projects/qran.png",
      github: "https://github.com/BelghithAdem/quran-app",
      live: "https://quran-web-app.pages.dev/",
      category: "academic",
      description: [
        "Modern web application for Quran reading.",
        "Intuitive user interface with Vue 3 + Vite.",
        "Advanced search and navigation features."
      ]
    }
  ],
  skills: {
    frontend: [
      { name: "Vue.js", level: "Pro" },
      { name: "React", level: "Pro" },
      { name: "Next.js", level: "Pro" },
      { name: "React Native", level: "Pro" },
      { name: "Expo", level: "Pro" },
      { name: "Tailwind CSS", level: "Pro" },
      { name: "TypeScript", level: "Pro" }
    ],
    backend: [
      { name: "Node.js", level: "Pro" },
      { name: "NestJS", level: "Pro" },
      { name: "FastAPI", level: "Pro" },
      { name: "WebSocket", level: "Pro" },
      { name: "Python", level: "Pro" }
    ],
    databases: [
      { name: "PostgreSQL", level: "Pro" },
      { name: "MySQL", level: "Pro" },
      { name: "MongoDB", level: "Pro" },
      { name: "Redis", level: "Pro" },
      { name: "Vector Database", level: "Pro" }
    ],
    devops: [
      { name: "Docker", level: "Pro" },
      { name: "Kubernetes", level: "Pro" },
      { name: "GitLab CI/CD", level: "Pro" },
      { name: "AWS", level: "Pro" },
      { name: "Helm", level: "Pro" },
      { name: "Prometheus", level: "Pro" },
      { name: "Grafana", level: "Pro" },
      { name: "Storybook", level: "Pro" },
      { name: "Turborepo", level: "Pro" }
    ],
    ai: [
      { name: "Generative AI", level: "Pro" },
      { name: "Agentic AI", level: "Pro" },
      { name: "LangChain", level: "Pro" },
      { name: "LangGraph", level: "Pro" },
      { name: "Semantic Search", level: "Pro" },
      { name: "RAG Pipeline", level: "Pro" },
      { name: "Prompt Engineering", level: "Pro" },
      { name: "Google Gemini", level: "Pro" },
      { name: "OpenAI API", level: "Pro" }
    ]
  },
  education: [
    {
      institution: "Tek-up",
      location: "Ariana, Tunisia",
      program: "Engineering Cycle in Computer Science - Software Engineering and Information Systems Engineering Degree",
      date: "2023 – 2026"
    },
    {
      institution: "ISET",
      location: "Kairouan, Tunisia",
      program: "Computer Technology License - Specialized in computer technology",
      date: "2020 – 2023"
    }
  ],
  certifications: [
    {
      name: "Full Stack Spring Boot 3",
      issuer: "Udemy",
      date: "2024",
      url: "https://www.udemy.com/certificate/UC-45a85e28-6ba5-4ef9-bb27-1094c0b73426/"
    },
    {
      name: "Docker Certification",
      issuer: "Udemy",
      date: "2023",
      url: "https://www.udemy.com/certificate/UC-25dc890e-931f-448a-91ad-9b65be392408/"
    },
    {
      name: "Agile Fundamentals",
      issuer: "SCRUMstudy",
      date: "2024",
      url: "https://www.scrumstudy.com/certification/verify?type=SFC&number=1009321"
    }
  ],
  languages: {
    "English": "Fluent",
    "French": "Competent",
    "Arabic": "Native"
  }
}; 